module.exports = __webpack_public_path__ + "static/media/nissan-minus.c05b98e9.svg";